import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { Tooltip } from '#pplx/frontend/aether/components/Tooltip/index.js';
import { useSourcesMenuConfig } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuConfigContextSupport.js';
import { useCometMcpServers } from '#pplx/frontend/apps/ask/comet-browser/hooks/useCometMcpServers.js';
import { useSourceMeta } from '#pplx/frontend/apps/ask/sources/hooks/useSourceMeta.js';
import { getCometMcpServerName } from '#pplx/frontend/apps/ask/sources/types/cometMcpSourceTypes.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { memo } from 'react';
export const SourcesMenuItemCometMcpSource = memo(function SourcesMenuItemCometMcpSource({ source, enabled, onToggle }) {
    const { cometMcpSources } = useCometMcpServers();
    const { label, getIcon } = useSourceMeta({ sourceId: source });
    const { hideDescriptionOverlays } = useSourcesMenuConfig();
    const serverName = getCometMcpServerName(source);
    const serverConfig = cometMcpSources[serverName];
    if (!serverConfig) {
        logger.error(`Server config not found for comet MCP source: ${source}`);
    }
    const description = serverConfig?.description;
    const menuItem = (_jsx(DropdownMenu.CheckboxItem, { leadingAccessory: getIcon('small'), checked: enabled, onCheckedChange: onToggle, disabled: serverConfig?.disabled, children: label }));
    if (description && !hideDescriptionOverlays) {
        return (_jsx(Tooltip, { content: description, side: "right", children: menuItem }));
    }
    return menuItem;
});
//# sourceMappingURL=SourcesMenuItemCometMcpSource.js.map